import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import TimerView from '../views/TimerView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/timer',
    name: 'timer',
    component: TimerView
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
